<template>
    <div class="notice">
      <div>
        <span class="back" @click="routerTo('/mpage/m_notice')">
          <img src="../img/arrow.png" alt=""> 首页
        </span>
      </div>
      <div class="content">
        <h2 class="title">
          图片故事作品规则
        </h2>
        <p>
          1.志愿者在参加选拔、培训以及任教期间拍摄的或以他人视角拍摄的与志愿者有关的摄影作品，作品需3张以上,并具有故事性；
        </p>
        <p>
          2.3张以上图片以故事组的形式进行上传，要求参赛者通过作品的故事情节、整体图片的拍摄、构图及用光、用色等进行评审；
          同时要求参赛者进行同一主题的多幅作品拍摄，要求真实、多角度地反映志愿者、中文教师的工作与生活、所见与所感，专家也将以此进行评审，全部作品不得摆拍；
        </p>
        <p>
          3.图片中不得带有黄、赌、毒及任何带有政治色彩的画面。
        </p>
        <p>
          4.故事图组题目限定在50字以内；图组及图组中的图片描述在150字以内；另需根据要求注明拍摄时间、拍摄地点等信息；
        </p>
        <p>
          5.在提交“故事图组”作品时，每组最少为3张图片，最多为10张，并通过文字说明故事中的内容，文字内容需与图片内容相符，否则不予通过审核，不能进行展示；
        </p>
        <p>6.要求不得对原始照片进行影响其真实性的改动，不得进行任何形式的装裱，但可进行调光或图片大小的微调整；</p>
        <p>7.每位参赛者最多可上传10组图组，并提交参赛；</p>
        <p>8.图片作品格式要求为JPG格式，故事图组中每单幅图片原始文件大小不小于2MB，不大于5MB。</p>
      </div>
    </div>
</template>

<script>
export default {
    name: 'notice',
    data: function () {
        return {
            
        }
    },
    methods: {
      routerTo(path) {
        this.$router.push(path)
      }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.notice {
    width: 100%;
    margin: 0.29rem auto 0.45rem;
    text-align: center;
    font-size: 20px;
    text-align: left;
    .back {
      font-size: 0.36rem;
      color: #0b0b0b;
      font-weight: bold;
      cursor: pointer;
      img {
        vertical-align: middle;
        width: 0.26rem;
        margin-top: -0.1rem;
        margin-left: 0.45rem;
      }
    }
    .content {
      width: calc(100% - 0.9rem);
      background-color: #fff;
      padding: 0 0.45rem 0.6rem;
      box-sizing: border-box;
      margin: 0 0.45rem;
      text-align: center;
      margin-top: 0.8rem;
      &:last-child {
        padding-bottom: 5.6rem;
      }
      .title {
        position: relative;
        top: -0.45rem;
        width: 47%;
        height: 0.9rem;
        line-height: 0.88rem;
        margin: auto;
        background-image: linear-gradient(0deg, 
          #746bef 0%, 
          #728bf9 100%);
        border-radius: 0.44rem;
        text-align: center;
        font-size: 0.6rem;
        color: #fff;
        font-weight: bold;
        &:before {
          position: absolute;
          left: -1.1rem;
          top: 0.2rem;
          content: '';
          display: inline-block;
          width: 0.8rem;
          height: 0.8rem;
          background-image: url(../img/left.png);
          background-size: contain;
          background-repeat: no-repeat;
        }
        &:after {
          position: absolute;
          right: -1.2rem;
          top: 0.2rem;
          content: '';
          display: inline-block;
          width: 0.8rem;
          height: 0.8rem;
          background-image: url(../img/right.png);
          background-size: contain;
          background-repeat: no-repeat;
        }
      }
      p {
        text-align: left;
        font-size: 0.45rem;
        color: #0b2ab0;
        line-height: 1.6;
        text-indent: 2em;
      }
      .p_left {
        text-indent: 0;
      }
      h2 {
        font-size: 0.45rem;
        font-weight: bold;
        color: #0b2ab0;
        text-align: left;
        margin-top: 0.4rem;
      }
      h3 {
        font-size: 0.45rem;
        line-height: 1.4;
        color: #0b2ab0;
        text-align: left;
        margin-top: 0.35rem;
        text-indent: 1em;
      }
    }
    .link {
      position: relative;
      margin-top: 0.73rem;
      &:before {
        content: '';
        position: absolute;
        left: 1rem;
        top: -1.2rem;
        background-image: url(../img/link.png);
        background-repeat: no-repeat;
        background-size: 100%;
        width: 0.32rem;
        height: 1.6rem;
      }
      &:after {
        content: '';
        position: absolute;
        right: 1rem;
        top: -1.2rem;
        background-image: url(../img/link.png);
        background-repeat: no-repeat;
        background-size: 100%;
        width: 0.32rem;
        height: 1.6rem;
      }
    }
}
</style>
